import React, { useMemo } from 'react';
import {
  PreferenceSection as IPreferenceSection,
  usePreferences,
} from '@trycourier/react-hooks';
import { IonList } from '@ionic/react';
import Topic from './Topic';

interface PreferenceSectionProps {
  section: IPreferenceSection['nodes'][number];
  isAdmin: boolean;
}

const ALLOWED_CHANNELS = ['sms', 'email', 'push'];

const PreferenceSection: React.FC<PreferenceSectionProps> = ({
  section,
  isAdmin,
}) => {
  const { recipientPreferences, updateRecipientPreferences } = usePreferences();
  const filteredChannels = section.routingOptions.filter((option) =>
    ALLOWED_CHANNELS.includes(option)
  );

  const memoizedTopics = useMemo(() => {
    return section.topics.nodes.map((topic) => {
      return {
        topic: topic,
        recipientPreference: recipientPreferences?.find((preference) => {
          if (preference.templateId === topic.templateId) {
            return preference;
          }
        }),
      };
    });
  }, [section, recipientPreferences]);

  if (!recipientPreferences) {
    return null;
  }

  return (
    <IonList>
      {memoizedTopics.map(({ topic, recipientPreference }, i) => (
        <Topic
          key={i}
          topic={topic}
          isAdmin={isAdmin}
          filteredChannels={filteredChannels}
          section={section}
          recipientPreference={recipientPreference}
          updateRecipientPreferences={updateRecipientPreferences}
        />
      ))}
    </IonList>
  );
};

export default PreferenceSection;
